import { render } from "./OcrConfirmation.vue?vue&type=template&id=4f82bd62&scoped=true"
import script from "./OcrConfirmation.vue?vue&type=script&lang=js"
export * from "./OcrConfirmation.vue?vue&type=script&lang=js"

import "./OcrConfirmation.vue?vue&type=style&index=0&id=4f82bd62&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f82bd62"]])

export default __exports__